<template>
  <div class="board">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="board_title">
            <Title current-name="Меню">
              {{ pageTitle }}
            </Title>
          </div>
        </div>
      </div>
    </div>
    <div class="board_masonry">
      <Masonry />
    </div>
    <!--    <div class="board_promo">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <PromoSlider :items="promoList" />
          </div>
        </div>
      </div>
    </div>-->
    <!--    <div class="board_download">
      <DownloadJumbo />
    </div>-->
  </div>
</template>

<script>
import Title from '@/components/UI/Title'
import Masonry from '@/components/page/MasonryGrid'
// import DownloadJumbo from '@/components/page/DownloadJumbo'
// import PromoSlider from '@/components/page/PromoSlider'
import { mapGetters } from 'vuex'

export default {
  components: {
    Title,
    Masonry,
    /* DownloadJumbo,
    PromoSlider, */
  },
  computed: {
    ...mapGetters({
      pageTitle: 'seo/getPageTitle',
    }),
  },
  asyncData ({ store }) {
    /** Set default meta tags */
    store.commit('seo/setMetaFieldsDefaults', {
      metaTitle: `Меню ресторанов СУШИСЕТ ${store.getters['region/getCurRegionNamePadeg']}`,
      metaDescription: `СУШИСЕТ доставит вам домой или в офис ${store.getters['region/getCurRegionNamePadeg']} вкуснейшие суши, роллы, супы, закуски и безалкогольные напитки.`,
      pageTitle: `Меню`,
    })
  },
}
</script>

<style lang="less">
.board {
  padding-top: 20px;

  &_title {
    margin-bottom: 15px;
  }

  &_masonry {
    display: flex;
    margin-bottom: 48px;
  }

  &_promo {
    display: flex;
    margin-bottom: 53px;
  }

  @media screen and (max-width: 992px) {
    padding-top: 50px;
  }
}
</style>
